/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { Box, Container, Grid } from '@mui/material';
import { ScenarioAPIPermissions, ToolAPIPermissions } from '@poweralpha/common';
import { Activity } from 'react';
import { hasAgentPermission } from '../agent/permissions';
import { usePermissions } from '../auth';
import { hasFimoConfigAccessPermission } from '../fimo/permissions';
import ActionableBidRequests from './components/ActionableBidRequests';
import AgentQuickStart from './components/agent-quick-start/AgentQuickStart';
import LastSimulations from './components/LastSimulations';
import ProjectListing from './components/project-listing/ProjectListing';
import RecentConfigs from './components/RecentConfigs';
import RecentDbComponents from './components/RecentDbComponents';
import RecentPricings from './components/RecentPricings';
import RunningWorkflows from './components/RunningWorkflows';
import SiteMap from './components/SiteMap';

const servicePermissions = [
  ToolAPIPermissions.READ_ESSCOSTING,
  ToolAPIPermissions.READ_PVCOSTING,
  ToolAPIPermissions.READ_PVSIM,
  ToolAPIPermissions.WRITE_PLANTSIM,
];

function Home() {
  const permissions = usePermissions();
  const hasBrPermission = permissions?.some((permission) =>
    Object.values(ScenarioAPIPermissions).includes(permission),
  );
  const hasServicePermissions = permissions?.some((permission) =>
    servicePermissions.includes(permission),
  );
  const hasServiceOrFimoPermissions =
    hasServicePermissions || hasFimoConfigAccessPermission(permissions);
  const masonryColumns = { xs: 1, sm: 2, lg: 3 };
  const tileSx = {
    breakInside: 'avoid',
    display: 'inline-block',
    mb: { sm: 2, xs: 1.5 },
    width: '100%',
  };

  return (
    <Container maxWidth={false} sx={{ mb: 2, px: { lg: 3, sm: 2, xs: 1 } }}>
      <Grid container spacing={{ sm: 2, xs: 1.5 }}>
        <ProjectListing />
      </Grid>
      <Box
        sx={{
          columnCount: masonryColumns,
          columnGap: { sm: 2, xs: 1.5 },
          mt: { sm: 2, xs: 1.5 },
        }}
      >
        <Activity mode={hasAgentPermission(permissions) ? 'visible' : 'hidden'}>
          <Box sx={tileSx}>
            <AgentQuickStart />
          </Box>
        </Activity>
        <Activity mode={hasBrPermission ? 'visible' : 'hidden'}>
          <Box sx={tileSx}>
            <ActionableBidRequests />
          </Box>
        </Activity>
        <Box sx={tileSx}>
          <SiteMap />
        </Box>
        <Box sx={tileSx}>
          <RecentPricings />
        </Box>
        <Activity mode={hasServicePermissions ? 'visible' : 'hidden'}>
          <Box sx={tileSx}>
            <LastSimulations />
          </Box>
        </Activity>
        <Activity mode={hasServicePermissions ? 'visible' : 'hidden'}>
          <Box sx={tileSx}>
            <RunningWorkflows />
          </Box>
        </Activity>
        <Activity mode={hasServiceOrFimoPermissions ? 'visible' : 'hidden'}>
          <Box sx={tileSx}>
            <RecentConfigs />
          </Box>
        </Activity>
        <Activity mode={hasServicePermissions ? 'visible' : 'hidden'}>
          <Box sx={tileSx}>
            <RecentDbComponents />
          </Box>
        </Activity>
      </Box>
    </Container>
  );
}

export default Home;
